<template>
  <div>
    <!-- <NavMenu /> -->
    <div class="unauthenticatedPage">
      <v-layout wrap align-center justify-center fill-height>
        <v-container>
          <v-layout wrap align-center justify-center fill-height>
            <v-card
              style="padding: 4vh; border-radius: 20px"
              max-width="25%"
              min-width="25%"
            >
              <v-row>
                <v-col md="12" xs="12">
                  <div>
                    <div
                      class="text-center"
                      style="
                        color: #fb3d6b;
                        font-weight: 700;
                        font-size: 24px;
                        margin-bottom: 22px;
                      "
                    >
                      {{ $t('description.404') }}
                    </div>
                    <v-row class="mt-10">
                      <v-col
                        cols="12"
                        sm="12"
                        xl="12"
                        style="padding: 0"
                        class="my-1 d-xl-flex justify-xl-center"
                      >
                        <v-btn
                          style="
                            width: 40%;
                            color: #fff;
                            text-transform: unset !important;
                            background-color: #0077d5;
                            padding: 2vh 3vh;
                            border-radius: 30px !important;
                            font-weight: bolder;
                          "
                          elevation="0"
                          class="darken-1"
                          type="submit"
                          @click="$router.push({ name: 'home' })"
                        >
                          {{ $t('buttons.back') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-layout>
        </v-container>
      </v-layout>
    </div>
  </div>
</template>
<script>
import NavMenu from '../components/NavMenu.vue';

export default {
  data() {
    return {};
  },
  components: { NavMenu },
  mounted() {},
  methods: {},
};
</script>
